//
//
//
//
//
//
//

import api from "@/api"
export default {
    name: 'App',
    data () {
        return {
            pcOMobile:'pcPage',
            isRouterAlive:true,
        }
    },
    created() {
        if (this._isMobile()) { //手机端
            this.pcOMobile = 'mobilePage'
        } else { //pc
            this.pcOMobile = 'pcPage'
        }
    },
    mounted() {
    },
    mounted() {
        // 监听页面关闭/刷新事件
        window.addEventListener('beforeunload', this.handleBeforeUnload);
    },

    beforeDestroy() {
        // 组件销毁时移除监听
        window.removeEventListener('beforeunload', this.handleBeforeUnload);
    },
    methods: {
        handleBeforeUnload() {
      // 1. 使用 sendBeacon 发送退出请求
      const url = api.Logout; // 你的退出接口URL
      const token = localStorage.getItem('token'); // 获取认证token
      
      // 构造请求数据（根据API需要）
      const data = new URLSearchParams();
      data.append('token', token);
      
      // 使用 sendBeacon 发送请求
      if (navigator.sendBeacon) {
        navigator.sendBeacon(url, data);
      } else {
        // 兼容方案：同步AJAX请求
        this.sendSyncLogoutRequest(url, token);
      }
      console.log('执行页面刷新');
      
      // 2. 立即清除本地存储（不需要等待响应）
    //   window.localStorage.clear();
    },

    // 同步AJAX请求的兼容方案
    sendSyncLogoutRequest(url, token) {
      const xhr = new XMLHttpRequest();
      xhr.open('POST', url, false); // 同步请求
      xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
      xhr.send(`token=${encodeURIComponent(token)}`);
    },

    // 正常退出时使用的方法
    normalLogout() {
      this.axios.post(api.Logout).then((res) => {
        if(res.data.code == 200) {
          window.localStorage.clear();
        }
      })
    },
        _isMobile() {
            let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
            return flag;
        },
    },
    watch:{   //监听路由变化
        $route( to , from ){
            window.scrollTo(0,0)
            this.isRouterAlive = false
            this.$nextTick(() => (this.isRouterAlive = true)) 
        }
    }
}



// WEBPACK FOOTER //
// ./src/App.vue